import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Shuttle"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.3575 12L17.1075 4.83C16.9708 4.62766 16.7441 4.50454 16.5 4.5H2.25C1.83579 4.5 1.5 4.83579 1.5 5.25V18C1.5 18.4142 1.83579 18.75 2.25 18.75H3.855C4.21005 20.0565 5.39614 20.9632 6.75 20.9632C8.10386 20.9632 9.28995 20.0565 9.645 18.75H14.355C14.71 20.0565 15.8961 20.9632 17.25 20.9632C18.6039 20.9632 19.79 20.0565 20.145 18.75H21.75C22.1642 18.75 22.5 18.4142 22.5 18V12.42C22.4959 12.2688 22.4463 12.1224 22.3575 12ZM15 6H16.1175L19.965 11.25H15V6ZM3 6H13.5V11.25H3V6ZM6.75 19.5C5.92157 19.5 5.25 18.8284 5.25 18C5.25 17.1716 5.92157 16.5 6.75 16.5C7.57843 16.5 8.25 17.1716 8.25 18C8.25 18.8284 7.57843 19.5 6.75 19.5ZM17.25 19.5C16.4216 19.5 15.75 18.8284 15.75 18C15.75 17.1716 16.4216 16.5 17.25 16.5C18.0784 16.5 18.75 17.1716 18.75 18C18.75 18.8284 18.0784 19.5 17.25 19.5ZM21 17.25H20.145C19.79 15.9435 18.6039 15.0367 17.25 15.0367C15.8961 15.0367 14.71 15.9435 14.355 17.25H9.645C9.28995 15.9435 8.10386 15.0367 6.75 15.0367C5.39614 15.0367 4.21005 15.9435 3.855 17.25H3V12.75H21V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Shuttle.vue"]]);
